import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Row, Col, Card, Form, Offcanvas, Button, Image } from 'react-bootstrap';
import Layout from "../../components/Layout.";
import transaction from "../../actions/transaction";
import auth from "../../actions/auth";
import {ReactComponent as NotifSvg} from './../../assets/icons/svg/notif.svg';
import {ReactComponent as ProfileSvg} from './../../assets/icons/svg/profile.svg';
import {ReactComponent as TransactionSvg} from './../../assets/icons/svg/transaction.svg';
import {ReactComponent as DownloadSvg} from './../../assets/icons/svg/download-doc.svg';
import {ReactComponent as CupSvg} from './../../assets/icons/svg/cup.svg';
import {ReactComponent as FilterSvg} from './../../assets/icons/svg/filter.svg';
import {ReactComponent as CheckSvg} from './../../assets/icons/svg/check.svg';
import dayjs from 'dayjs';
import {currencyConverter} from './../../utils/index';
import ListTransaction from "../../components/ListTransaction";
import master from "../../actions/master";

export default function HomeScreen() {
  const [trnc, setTrnc] = useState([]);
  const [user, setUser] = useState([]);
  const [partner, setPartner] = useState([]);
  const [viewBalance, setViewBalance] = useState(true);
  const [keyword, setKeyword] = useState('');
  const [trFilter, setTrFilter] = useState('all');
  const [filter, setFilter] = useState({
    limit:"name",
    filter:"name"
  });
  const [showConfirm, setShowConfirm] = useState(false);
  const handleCloseConfirm = () => setShowConfirm(false);
  const handleShowConfirm = () => setShowConfirm(true);
  const [showPartner, setShowPartner] = useState(false);
  const handleClosePartner = () => setShowPartner(false);
  const handleShowPartner = () => setShowPartner(true);
  const [selectMenu, setSelectMenu] = useState('');
  const [loading, setLoading] = useState(true);
  const [notifL, setLotifL] = useState([]);
  const limit_list = [
    {name:'Semua', path: 'name'},
    {name:'Terbaru', path: '-created_at'},
    {name:'Paling Lama', path: 'created_at'},
  ]
  const filter_list = [
    {name:'Semua', path: 'name'},
    {name:'Setor', path: 'Deposit Sampah'},
    {name:'Tarik', path: 'Withdraw Saldo'},
    {name:'Biaya', path: 'Biaya Jemput'},
  ]
  const [notifTr, setNotifTr] = useState([]);
  const [notifReq, setNotifReq] = useState([]);
  const [notifPick, setNotifPick] = useState([]);
  const [notifPickup, setNotifPickup] = useState([]);
  const [notifDep, setNotifDep] = useState([]);
  const [notifVerif, setNotifVerif] = useState([]);

  const navigate = useNavigate();
  const head_menu = [
    {path: '/notification', icon: <NotifSvg/>},
    {path: '/profile', icon: <ProfileSvg/>},
  ]
  const action_menu = [
    {name:'Mutasi', path: '/mutation', icon: <DownloadSvg/>},
    {name:'Tarik Saldo', path: '/balance', icon: <TransactionSvg/>},
  ]
  const handleClick = (urls) => {
     navigate(urls);
  };

  useEffect(() => {
    auth.actions.get_users().then((res)=>{
      setUser(res?.data)
      sessionStorage.setItem('profile', JSON.stringify(res?.data))
      setLoading(false);
    }).catch((err)=>{err});
    transaction.actions.get_transaction('-created_at', keyword).then((res)=>{
      setTrnc(res?.data)
    }).catch((err)=>{err});
    transaction.actions.get_partner().then((res)=>{
      setPartner(res?.data?.data);
    }).catch((err)=>{err});
    master.actions.get_notification().then((res) => {
      setNotifTr(res?.data?.data?.transaction);
      setNotifReq(res?.data?.data?.pickup_request);
      setNotifPick(res?.data?.data?.request_pickup);
      setNotifPickup(res?.data?.data?.pickup);
      setNotifDep(res?.data?.data?.trash_deposit);
      setNotifVerif(res?.data?.data?.client_verify);
    }).catch((err)=>{err});
  },[])

  const getTransaction = (pr, key) => {
    setTrFilter(pr);
    setKeyword(key);
    setLoading(true);
    handleCloseConfirm();
    if(pr === 'all'){
      setFilter({limit:'name', filter: 'name'});
      transaction.actions.get_transaction('-created_at', key).then((res)=>{
        setTrnc(res?.data)
        setLoading(false);
      }).catch((err)=>{err});
    } else {
      if(filter.filter === 'name'){
        transaction.actions.get_transaction( filter.limit, key).then((res)=>{
          setTrnc(res?.data)
          setLoading(false);
        }).catch((err)=>{err});
      } else {
        transaction.actions.get_transaction( filter.limit, filter.filter).then((res)=>{
          setTrnc(res?.data)
          setLoading(false);
        }).catch((err)=>{err});
      }
    }
  }

  const handleChangeMitra = (e, path) => {
    navigate(`/${path}/${e.id}`)
    handleClosePartner();
  }

  return (
   <Layout active={1}>
      <div className="bg-radial-green p-4">
        <Row className="align-items-center">
          <Col xs={8}>
            <div className="d-flex align-items-center">
              <div className="text-smooth ts-sm">Lokasi Kamu</div>
              <i className="ph-caret-down ms-2 text-light"></i>
            </div>
            <div className={"text-light " + (loading ? "skeleton": '')}>
              {user?.address ? user?.address + ', ' : null} {user?.village?.name}
            </div>
          </Col>
          <Col xs={4}>
            <div className="d-flex align-items-center justify-content-end">
              {head_menu.map((item, key)=>{
                return (
                  <div key={key} className="header-items ms-2" onClick={() => handleClick(item.path)}>
                    {item.icon}
                    {item.path === '/notification' && (notifTr || notifReq || notifPick || notifPickup || notifDep || notifVerif) ?
                      <div className="notify"></div> : ''  
                    }
                  </div>
                )
              })}
            </div>
          </Col>
        </Row>

        <Row className="mt-3 p-3">
          <Card className="card-smooth-shadow-top">
            <Card.Body>
              <div className="text-smooth text-center my-1">{dayjs(user?.created_at).format('DD/MMMM YYYY')}</div>
              <h2 className={"text-light text-center " + (loading ? "skeleton": '')}>{user?.name}</h2>
              <Row className="align-items-center mt-3">
                <Col xs={6} className="border-right-smooth px-2">
                  <div className="text-smooth">Total Saldo Anda</div>
                  <div className="d-flex align-items-center justify-content-between">
                    <h5 className="mb-0">
                    {viewBalance ? 
                      <span className="text-light fw-bold">{currencyConverter(user?.balance)}</span> : 
                      <span className="text-light fw-bold">Rp•••••••</span>
                    }
                    </h5>
                    <div onClick={() => setViewBalance(!viewBalance)}>
                      {viewBalance ? 
                        <i className="ph-eye ms-2 text-light"></i> : 
                        <i className="ph-eye-slash ms-2 text-light"></i> 
                      }
                    </div>
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="d-flex align-items-center justify-content-between">
                    {action_menu.map((item, key)=>{
                      return(
                        <div key={key} className="home-action-items" onClick={() => {handleShowPartner(); setSelectMenu(item?.path)}}>
                          <div className="hai-icon">{item.icon}</div>
                          <div className="hai-text">{item.name}</div>
                        </div>
                      )
                    })}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Row>
      </div>
      <div className="bg-gray p-4">
        <Card className="card-info">
          <Card.Body className="p-3">
            <Row className="align-items-center">
              <Col xs={2}><CupSvg/></Col>
              <Col xs={10}>
                { loading ?
                  <div className="skeleton skeleton-bar"></div>:
                  <>
                    <div className="ts-xs lh-small text-muted">
                      Terimakasih! Anda telah turut berkontribusi dalam menjaga kebersihan lingkungan dari sampah.
                    </div>
                    <small className="fw-bold lh-normal">
                      Total sampah yang dikumpulkan {user?.total_trash_weight} Kg
                    </small>
                  </>
                }
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </div>

        <div className="px-4 mt-4 content-height">
          <div className="d-flex align-items-center justify-content-between">
            <Form.Control placeholder="Cari transaksi" className="me-3" onChange={(e) => getTransaction(trFilter, e.target.value)}/>
            <div onClick={() => handleShowConfirm()}><FilterSvg/></div>
          </div>
          <h6 className="text-muted mt-3">Riwayat Transaksi</h6>
          {loading?
            <div>
              <div className="skeleton skeleton-list mb-3"></div>
              <div className="skeleton skeleton-list mb-3"></div>
              <div className="skeleton skeleton-list mb-3"></div>
              <div className="skeleton skeleton-list mb-3"></div>
            </div> :
            ( trnc ?
              <>
                {trnc.map((item, key) => {
                  return (<ListTransaction data={item} key={key} notarrow/>)
                })}
              </> : 
              <div className="text-secondary text-center p-3 ts-sm">
                Tidak ada list transaksi
              </div>
            )
          }
      </div>

      <Offcanvas show={showConfirm} onHide={handleCloseConfirm} placement="bottom" className="h-auto">
         <Offcanvas.Header closeButton>
            <Offcanvas.Title>Filter</Offcanvas.Title>
         </Offcanvas.Header>
         <Offcanvas.Body className="py-4">

          <div className="listing mb-3">
            <div className="text-secondary mb-3">Data Riwayat</div>
            <div className="d-flex align-items-center">
              {limit_list.map((data,key)=>{
                return ( 
                <div className={'d-flex align-items-center py-2 px-3 me-2 rounded-pill' + (data.path === filter.limit ? ' btn-success text-white' : ' bg-gray')} 
                  key={key}
                  onClick={() => setFilter({...filter, ...{limit: data.path}})}
                >
                  {data.name}
                  {data.path === filter.limit ?
                    <CheckSvg className="ms-1"/> : null
                  }
                </div>
                )
              })}
            </div>
          </div>
          <div className="listing mb-4">
            <div className="text-secondary mb-3">Jenis Transaksi</div>
            <div className="d-flex align-items-center">
              {filter_list.map((data,key)=>{
                return ( 
                <div className={'d-flex align-items-center py-2 px-3 me-2 rounded-pill' + (data.path === filter.filter ? ' btn-success text-white' : ' bg-gray')} 
                  key={key}
                  onClick={() => setFilter({...filter, ...{filter: data.path}})}
                >
                  {data.name}
                  {data.path === filter.filter ?
                    <CheckSvg className="ms-1"/> : null
                  }
                </div>
                )
              })}
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center w-100">
              <Button type="button" className="rounded-pill py-2 me-3 w-50 d-flex align-items-center justify-content-center" variant="success-opacity" onClick={() => getTransaction('all', keyword)}>
                Atur Ulang
              </Button>
              <Button onClick={() => getTransaction('custom',keyword)} className="rounded-pill py-2 w-50" variant="success">
                Terapkan
              </Button>
          </div>
         </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas show={showPartner} onHide={handleClosePartner} placement="bottom" className="h-auto">
         <Offcanvas.Header closeButton>
            <Offcanvas.Title>Pilih Mitra</Offcanvas.Title>
         </Offcanvas.Header>
         <Offcanvas.Body className="p-0">
         {partner.length && partner.map((item, key)=> {
               return(
                  <div className="p-3 border-bottom" key={key} onClick={() => {handleChangeMitra(item, selectMenu)}}>
                     <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                           <Image src={item.avatar} className="br-avatar me-3" width="50px" height="50px"/>
                           <div className="selected">
                              <h6 className="fw-bold mb-1">{item.name}</h6>
                              <small className="text-success">Terdaftar</small>
                           </div>
                        </div>
                        <div>
                           <i className="ph-caret-right fw-bold"></i>
                        </div>
                     </div>
                  </div>
                  )
            })
            }
         </Offcanvas.Body>
      </Offcanvas>
   </Layout>
  );
}